import makeRequest from './base.request'
import { STAGE_TYPE } from '../const';

export const getListaAtividades = async (idGrade, nuPeriod = 0, idPracticeTestType = 0, lstIdClass = [], idStudent = undefined) => {
    try {
        
        
        var idClass = lstIdClass.join(',');
        const response = await makeRequest.get(`acompanhamento/atividades-periodo?grade=${idGrade}`
            +(nuPeriod?`&period=${nuPeriod}`:'')
            +(idPracticeTestType?`&practicetesttype=${idPracticeTestType}`:'')
            +(idClass?`&class=${idClass}`:'')
            +(idStudent?`&student=${idStudent}`:'')
            );

        var lista = response.lista && response.lista[0];
        return lista || [];
    } catch (error) {
        console.error(error);
    }
}

export const setCorrecao = async (
    idStudentStudy,
    idAccount,
    idStudyStageResumo,
    comentarioResumo,
    notaResumo,
    idStudyStageQuestao,
    comentarioQuestao) => {
    try {
        
        var putData = {
            idStudentStudy: idStudentStudy,
            idStudent: idAccount,
            stages: [
                {
                    idStudyStage: idStudyStageResumo,
                    idStageType: STAGE_TYPE.RESUMO,
                    txComment: comentarioResumo,
                    nuScore: notaResumo
                },
                {
                    idStudyStage: idStudyStageQuestao,
                    idStageType: STAGE_TYPE.QUESTOES,
                    txComment: comentarioQuestao
                }
            ]
        }
        const response = await makeRequest.put('estudo/aluno', putData);
        return response;
        
    } catch (error) {
        console.error(error);
    }
}